import React, { useContext } from 'react'
import { addEllipses } from '../../Utils/utils'
import QuantityCounter from './QuantityCounter'
import { useDispatch } from 'react-redux'
import { removeFromCart } from '../../redux/actions/cartActions'
import { UserContext } from '../../Context/ContextProvider'

const CartItem = ({cartItem}) => {
    const dispatch=useDispatch();
    const {user}=useContext(UserContext);

    const handleRemoveFromCart=()=>{
        if(user)
            dispatch(removeFromCart(cartItem.id))
    }
  return (
    <>
    <div className='flex flex-col mx-[12px]'>
        <div className='flex items-center space-x-4 my-[50px]'>
            <div className=''>
                <img src={cartItem.url} alt="" className='h-[80px] w-[100px] md:h-[150px]'/>
            </div>
            <div>
                <div className='font-bold'>{cartItem.title.shortTitle} </div>
                <div> {addEllipses(cartItem.title.longTitle)} </div>
                <div className='flex space-x-5'>
                    <div className='text-green-600'>₹{cartItem.price.cost}</div>
                    <div className='line-through'>₹{cartItem.price.mrp}</div>
                    <div className='text-red-600'>{cartItem.price.discount} off</div>
                </div>
                <div className='flex space-x-4'>
                    <button className={` px-[12px] py-[10px] rounded-lg shadow-lg my-4 text-white text-[12px] ${user? 'bg-pink-600':'bg-pink-300'}`} onClick={handleRemoveFromCart}>Remove from cart</button> 
                    <QuantityCounter/>              
                </div>
            </div>
        </div>
        <hr />
    </div>
    </>
  )
}

export default CartItem
